<template>
  <div>
    <button id="btn-signin" type="button" @click="loginPortal" v-if="!isSignedIn">Sign In</button>
    <button id="btn-signout" type="button" @click="logoutPortal" v-if="isSignedIn">Sign Out</button>
    <!-- <button id="btn-api" type="button" @click="myCallApi" v-if="isSignedIn">Call API</button> -->
    <!-- <hr v-if="isSignedIn"/>
    <br /><br /> -->
    <!-- <input id="file-input" type="file" ref="fileInput" v-if="isSignedIn" />
    <button id="btn-upload" type="button" @click="myUploadFile" v-if="isSignedIn">Upload File</button> -->
    <!-- <hr v-if="isSignedIn"/>
    <br /><br /> -->
    <div id="result" v-show="result">{{ result }}</div>
    <div v-if="isSignedIn">
      <PortalHeader />
      <div>
        <div class="widget-enforced">
          <PortalLinks />
          <MyFavourites />
        </div>
        <div class="widget-optional">
          <DataProtectionOfficeArticles />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import '@/assets/bootstrap.min.css';
import '@/assets/base.css';
import '@/assets/hkuCust.css';
import '@/assets/main.css';
import '@/assets/Poppins.css';
import '@/assets/Source-San-3.css';
import { ref, onMounted } from 'vue';
import { login, logout } from '@/functions/site';
import { graphApi } from '@/functions/Dataverse';
import PortalHeader from '@/components/PortalHeader.vue';
import PortalLinks from '@/components/PortalLinks.vue';
import MyFavourites from '@/components/MyFavourites.vue';
import DataProtectionOfficeArticles from '@/components/DataProtectionOfficeArticles.vue';

let result = ref('');
const isSignedIn = ref(false);

async function myCallApi() {
  try {
    const userInfo = await graphApi();
    if (userInfo && userInfo.displayName) {
      isSignedIn.value = true;
    } else {
      isSignedIn.value = false;
    }
  } catch {
    console.log('Not signed in');
  }
}

// async function myUploadFile() {
//   await uploadFile();
//   result.value = document.getElementById("result").innerText;
// }

async function loginPortal() {
  await login();
}

async function logoutPortal() {
  await logout();
}

onMounted(() => {
  myCallApi();
});
</script>

<style scoped>
/* Add your styles here */
#result {
  display: none;
}

html,
body,
p,
.p,
.page_section p,
.section-diagonal-left p,
.section-diagonal-right p,
footer .footer-bottom p,
select, option, label, span, button, input {
  font-size: 14px;
  font-family: 'Source Sans 3', 'Microsoft YaHei', 'Microsoft JhengHei', "Glyphicons Halflings", sans-serif !important;
  font-weight: 400;
}

h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: 'Source Sans 3', 'Microsoft YaHei', 'Microsoft JhengHei', sans-serif !important;
  font-weight: 400;
}

a {
  text-decoration: none;
}


.widget-enforced {
  padding: 0 1rem;
}

.widget-optional {
  padding: 0 1rem;
}
</style>